import { ReactNode } from 'react'

interface TherapyCardProps {
  icon: ReactNode
  title: string
  description: string
  image: string
}

export default function TherapyCard({ icon, title, description, image }: TherapyCardProps) {
  return (
    <div className="bg-white rounded-lg overflow-hidden">
      <div className="flex flex-col h-full">
        <div className="relative w-full aspect-[16/9] overflow-hidden rounded-t-lg bg-gray-200">
          <img
            src={image}
            alt={title}
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>
        <div className="p-5">
          <div className="flex items-center gap-3 mb-3">
            <div className="text-[#003CFF]">{icon}</div>
            <h3 className="headline-medium mb-0">{title}</h3>
          </div>
          <p className="body text-gray-600 w-full">
            {description}
          </p>
        </div>
      </div>
    </div>
  )
} 